// src/redux/tratamientos/tratamientosActions.js

import { db } from "../../services/firebase/Config";
import { fetchLabs } from "../../services/firebase/labs/index";
import {
  SET_TRATAMIENTOS,
  UPDATE_TRATAMIENTO_IN_ARRAY,
  ADD_TRATAMIENTO_IN_ARRAY,
  REMOVE_TRATAMIENTO_IN_ARRAY,
} from "./tratamientosTypes";

import { httpRequest, httpSuccess, httpFailure } from "../sesion/sesionActions";
import { fetchTratamientosCompletos as fetchTratamientosCompletosRaw } from "../../services/firebase/tratamientos";

// CREATORS (objetos planos)
const setTratamientos = (payload) => ({ type: SET_TRATAMIENTOS, payload });
export const updateTratamientoInArray = (tratamiento) => ({
  type: UPDATE_TRATAMIENTO_IN_ARRAY,
  payload: tratamiento,
});
const addTratamientoInArray = (tratamiento) => ({
  type: ADD_TRATAMIENTO_IN_ARRAY,
  payload: tratamiento,
});
const removeTratamientoInArray = (tratamiento) => ({
  type: REMOVE_TRATAMIENTO_IN_ARRAY,
  payload: tratamiento,
});

// THUNKS

// thunk público que la vista debe despachar
export const fetchTratamientosCompletosThunk = (empresaId) => {
  return async (dispatch) => {
    dispatch(httpRequest());
    try {
      const tratamientos = await fetchTratamientosCompletosRaw(empresaId);
      dispatch(setTratamientos(tratamientos));
      dispatch(httpSuccess());
    } catch (err) {
      dispatch(httpFailure(err));
    }
  };
};

export const saveTratamiento = (empresaId, tratamiento) => {
  return async (dispatch) => {
    dispatch(httpRequest());
    try {
      const ref = db
        .collection("empresas")
        .doc(empresaId)
        .collection("tratamientos")
        .doc(tratamiento.id);
      tratamiento.empresaId = empresaId;
      await ref.set(tratamiento);
      dispatch(updateTratamientoInArray(tratamiento));
      dispatch(httpSuccess());
    } catch (err) {
      dispatch(httpFailure(err));
    }
  };
};

// Este es el update que la vista también importa
export const updateTratamiento = (empresaId, tratamiento) => {
  return async (dispatch) => {
    dispatch(httpRequest());
    try {
      const ref = db
        .collection("empresas")
        .doc(empresaId)
        .collection("tratamientos")
        .doc(tratamiento.id);
      await ref.set(tratamiento);
      dispatch(updateTratamientoInArray(tratamiento));
      dispatch(httpSuccess());
    } catch (err) {
      dispatch(httpFailure(err));
    }
  };
};

export const removeTratamiento = (empresaId, tratamiento) => {
  return async (dispatch) => {
    dispatch(httpRequest());
    try {
      const ref = db
        .collection("empresas")
        .doc(empresaId)
        .collection("tratamientos")
        .doc(tratamiento.id);
      await ref.update({ estado: "INACTIVO" });
      dispatch(updateTratamientoInArray({ ...tratamiento, estado: "INACTIVO" }));
      dispatch(httpSuccess());
    } catch (err) {
      dispatch(httpFailure(err));
    }
  };
};

export const addTratamiento = (empresaId, tratamiento) => {
  return async (dispatch) => {
    console.log("Adding tratamiento:", tratamiento);
    dispatch(httpRequest());
    try {
      const ref = db
        .collection("empresas")
        .doc(empresaId)
        .collection("tratamientos")
        .doc();
      tratamiento.id = ref.id;
      tratamiento.empresaId = empresaId;
      await ref.set(tratamiento);
      console.log("Tratamiento added:", tratamiento);
      dispatch(addTratamientoInArray(tratamiento));
      dispatch(httpSuccess());
    } catch (err) {
      dispatch(httpFailure(err));
    }
  };
};

export const addTratamientoYTarifario = (empresaId, tratamiento) => {
  return async (dispatch) => {
    dispatch(httpRequest());
    try {
      const batch = db.batch();
      const tratamientoRef = db
        .collection("empresas")
        .doc(empresaId)
        .collection("tratamientos")
        .doc();
      tratamiento.id = tratamientoRef.id;
      tratamiento.empresaId = empresaId;
      batch.set(tratamientoRef, tratamiento);

      const labs = await fetchLabs();
      labs.forEach((lab) => {
        const tarifarioRef = db.collection("tarifarios").doc();
        batch.set(tarifarioRef, {
          codigo: tratamiento.codLab,
          id: tarifarioRef.id,
          labId: lab.id,
          nombre: `${tratamiento.tratamiento} ${tratamiento.tipo || ""}`,
          precio: tratamiento.precio,
        });
      });

      await batch.commit();
      dispatch(addTratamientoInArray(tratamiento));
      dispatch(httpSuccess());
    } catch (err) {
      dispatch(httpFailure(err));
    }
  };
};

// Personaliza un tratamiento base
export const personalizarTratamientoBase = (tratamientoBase, empresaId) => {
  return async (dispatch) => {
    dispatch(httpRequest());
    try {
      console.log("Personalizando tratamiento base:", tratamientoBase);
      
      const personalizado = {
        ...tratamientoBase,
        origen: "personalizado",
        readOnly: false,
        codTra: tratamientoBase.codTra,
        empresaId,
        estado: true,
        fechaPersonalizacion: new Date().toISOString(),
        modificaciones: {},
        id: tratamientoBase.id, // Asegurar que tenga un ID
        subGrupoId: tratamientoBase.subGrupoId,
        codLab: tratamientoBase.codLab
        
      };

      const ref = db
        .collection("empresas")
        .doc(empresaId)
        .collection("tratamientos")
        .doc(tratamientoBase.id);

      await ref.set(personalizado);
      dispatch(updateTratamientoInArray(personalizado));
      dispatch(httpSuccess());
      return personalizado;
    } catch (err) {
      dispatch(httpFailure(err));
      throw err;
    }
  };
};
